(function () {
  'use strict';

  // Configuration is read from data-* attributes on the widget element so the
  // phone number / message can be managed from the Liquid snippet.
  function init() {
    var widget = document.getElementById('tp-whatsapp-widget');
    if (!widget) return;

    var phone = (widget.getAttribute('data-phone') || '').replace(/[^0-9]/g, '');
    var message = widget.getAttribute('data-message') || '';

    var href = 'https://api.whatsapp.com/send?phone=' + phone;
    if (message) {
      // WhatsApp's send endpoint expects '+' for spaces (form-style encoding).
      href += '&text=' + encodeURIComponent(message).replace(/%20/g, '+');
    }

    var link = widget.querySelector('.tp-wa-link');
    if (link) {
      link.setAttribute('href', href);
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');

      // Force a real top-level new tab. Inside framed contexts (e.g. the Shopify
      // theme editor preview) a plain target="_blank" can navigate the iframe
      // itself, and api.whatsapp.com refuses to be framed (X-Frame-Options),
      // producing ERR_BLOCKED_BY_RESPONSE. window.open guarantees a new context.
      link.addEventListener('click', function (event) {
        var opened = window.open(href, '_blank', 'noopener,noreferrer');
        if (opened) {
          event.preventDefault();
        }
        // If the popup was blocked, let the anchor's default navigation proceed.
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
